<template>
  <lazy-list-y
    :render="render"
    @initialize="initialize"
    @scrolly="scrolly"
    @updated="child_updated"
  >
    <template #default="scope"
      ><slot v-bind="add_height(scope)" name="default"></slot
    ></template>
  </lazy-list-y>
</template>

<script>
import _ from 'lodash'

import Vue from 'vue'

import {
  cumsum,
  lowerbound,
  next_power_of_two,
  gcd,
  justification_enum,
} from '@/utils.js'
import { vue_lazy_scroller_logicy } from '@/components/lazy_compute.js'

import LazyListY from '@/components/lazy_list_y.vue'

function retry_within_limit_until_success(f, nb_tries = 10) {
  let retry = nb_tries !== 0 && !f()
  if (retry) {
    Vue.nextTick(() => retry_within_limit_until_success(f, nb_tries - 1))
  }
}

// *****************************************************************************

export default {
  name: 'LazyListDisplayY',
  components: {
    LazyListY,
  },
  props: [
    'default_height',
    'nb',
    'variable_height_start_pos',
    'variable_heights',
  ],
  data() {
    return {
      render: {
        padding_low: 0,
        padding_high: 0,
        really_rendered_size: 0,
        component_start: 0,
        component_stop: 0,
        scroll: true,
        container: 'div',
        container_class: [],
        initialized: false,
        used_default_size: undefined,
      },
      running: false,
    }
  },
  my_lazy_list_handler: null,
  computed: {
    _() {
      return _
    },
  },
  watch: {
    nb(nv, ov) {
      if (nv !== ov) {
        this.$options.my_lazy_list_handler.set_nb_elements(nv)
        this.$options.my_lazy_list_handler.relayout()
      }
    },
    variable_height_start_pos(nv, ov) {
      if (nv !== ov) {
        this.$options.my_lazy_list_handler.set_variable_size_start_pos(nv)
        this.$options.my_lazy_list_handler.relayout()
      }
    },
    variable_heights(nv) {
      this.$options.my_lazy_list_handler.set_variable_sizes(nv)
      this.$options.my_lazy_list_handler.relayout()
    },
    'render.component_start': function() {
      this.fetch_data()
    },
    'render.component_stop': function() {
      this.fetch_data()
    },
  },
  created() {
    // created is the ideal place for initializing the non reactive
    // data because props/data are available but the html element
    // has not yet been inserted
    this.$options.my_lazy_list_handler = new vue_lazy_scroller_logicy(
      this.render,
      this.default_height,
      this.nb || 0
    )
    this.$options.my_lazy_list_handler.set_variable_size_start_pos(
      this.variable_height_start_pos
    )
    this.$options.my_lazy_list_handler.set_variable_sizes(this.variable_heights)
  },
  mounted() {
    this.running = true
    this.$options.my_lazy_list_handler.set_nb_elements(this.nb)
    this.$options.my_lazy_list_handler.relayout()
  },
  beforeDestroy() {
    this.running = false
  },
  methods: {
    initialize(main_elt, test_elt) {
      retry_within_limit_until_success(() => {
        let size = this.$options.my_lazy_list_handler.initialize(
          main_elt,
          test_elt
        )
        this.render.used_default_size = size
        const res = !_.isUndefined(size) && size !== 0
        // console.log(size)
        this.render.initialized = res
        return res
      })
    },
    scrolly() {
      this.$options.my_lazy_list_handler.handle_scroll()
    },
    fetch_data() {
      if (this.running) {
        this.$emit(
          'fetch_data',
          this.render.component_start,
          this.render.component_stop
        )
      }
    },
    add_height(scope) {
      const nb = scope.nby
      let res = this.render.used_default_size
      if (
        !_.isUndefined(this.variable_size_start_pos) &&
        !_.isUndefined(this.variable_sizes) &&
        this.variable_sizes.length !== 0
      ) {
        if (
          nb >= this.variable_size_start_pos &&
          nb < this.variable_size_start_pos + this.variable_sizes.length
        ) {
          res = this.variable_sizes[nb - this.variable_size_start_pos]
        }
      }
      Vue.set(scope, 'height', `height:${res}px;`)
      return scope
    },
    child_updated() {
      this.$options.my_lazy_list_handler.adjust_scroll()
    },
  },
}
</script>
